import React from 'react';
import { TextVariant } from '@naf/text';
import { TextListItem } from '@naf-simba/elements-textlist';
import { HeartEmpty, HeartFull } from '@naf-simba/building-blocks-icons/FavoriteAndRating';
import { useToggleFavoriteBenefit } from '@hooks/useToggleFavoriteBenefit';
import * as S from './BenefitBulletsCard.styles';

export interface BenefitBulletsCardProps {
  id?: string;
  slug?: string;
  title?: string;
  benefitTitle?: string;
  bullets?: string[];
  isFavorite?: boolean;
}

export const BenefitBulletsCard = ({ id, slug, title, benefitTitle, bullets, isFavorite }: BenefitBulletsCardProps) => {
  const {
    isFavorite: isFavorited,
    isToggling,
    toggleFavorite,
  } = useToggleFavoriteBenefit(id, slug, isFavorite, undefined, benefitTitle);

  return (
    <S.Container>
      <S.HeaderRow>
        {title && <S.Header variant={TextVariant.Header2}>{title}</S.Header>}
        {id && (
          <S.FavoriteButton
            icon={isFavorited ? HeartFull : HeartEmpty}
            color="secondary"
            shade="light"
            aria-label={isFavorited ? 'Fjern fra favoritter' : 'Legg til i favoritter'}
            disabled={isToggling}
            onClick={toggleFavorite}
          />
        )}
      </S.HeaderRow>
      <S.StyledCheckList variant="checked">
        {bullets.map((bullet) => (
          <TextListItem key={`bullet-${bullet}`}>{bullet}</TextListItem>
        ))}
      </S.StyledCheckList>
    </S.Container>
  );
};
